import { isAdresseValide } from "./Addons"
import {
	POINT_INTERET_TYPE_ADRESSE,
	POINT_INTERET_TYPE_COORDONNEES,
} from "../components/others/PointInteretComponent"

// POI saisi complètement (règle unique : fiche mission DepMissionV2 et
// adresse à formaliser d'une proposition d'assistance — revue 5, 🟠5).
// Adresse : rue + localité si le POI vient d'un garage (label posé), sinon
// adresse complète (N° facultatif, revue 15.10 M1) ; coordonnées : latitude
// + longitude ; Parc / Fourrière / Police… : un POI choisi (id).
export const isPoValid = (po) => {
	if (!po) return false
	if (po.type === POINT_INTERET_TYPE_ADRESSE) {
		const adresse = po.adresse || {}
		if (po.label) return !!(adresse.rue && adresse.localite)
		return isAdresseValide(adresse)
	}
	if (po.type === POINT_INTERET_TYPE_COORDONNEES) {
		const extra = (po.adresse || {}).extra_data || {}
		return !!(extra.latitude && extra.longitude)
	}
	return po.id !== null && po.id !== undefined
}
